import React, { useState, useEffect } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router-dom";
// import Main from "../layout/Main";
import schoolApi from "../../api/schoolApi";
import { Helmet } from "react-helmet";
import "../../resources/css/Student.css";
// import { ToastContainer } from "react-toastify";
// import Select from "react-select";
import { useOutletContext } from "react-router-dom";
function convertTo12HourFormat(time24Hour) {
  const [hours, minutes] = time24Hour.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12;
  return `${hours12}:${minutes < 10 ? "0" : ""}${minutes} ${period}`;
}

const ClassTimeTable = (props) => {
  let periodIndex = 0;
  const navigate = useNavigate();
  const [selectedStudent, setStudent] = useOutletContext();
  // const [selectedYear, setSelectedYear] = useState("");
  const [timeTableClass, setTimeTableClass] = useState([]);
  const [tempBody, setTempBody] = useState([]);
  const [selectedSessionId, setSessionId] = useState({});
  const [selectedStudentId, setStudentId] = useState({});
  const [studentData, setStudentDetails] = useState();

  useEffect(() => {
    async function fetchData() {
      try {
        if (selectedStudent) {
          console.log("Student Id Before API Called =>", selectedStudent);
          let studentDetails = await schoolApi.fetchStudentsById(
            selectedStudent.id
          );
          console.log("studentDetails@@@=>", studentDetails);
          setStudentDetails(
            studentDetails.studentRec ? studentDetails.studentRec : null
          );
          console.log("StudentDetails on Time Table =>", studentDetails);
          if (studentDetails.success === true) {
            console.log("studentDetails.success");
            const timetableData = await schoolApi.fetchTimetableRecords(
              studentDetails.studentRec.classid,
              studentDetails.studentRec.section_id
            );
            console.log("##timetableData", timetableData);
            if (timetableData.success === true) {
              timetableData.timeSlotsResult?.forEach((item) => {
                console.log("itemmm=>", item);
                item?.data?.forEach((item) => {
                  console.log("itemmm2090=>", item);
                  if (
                    item?.timetable?.start_time &&
                    item?.timetable?.end_time
                  ) {
                    const startTime = convertTo12HourFormat(
                      item?.timetable?.start_time
                    );
                    const endTime = convertTo12HourFormat(
                      item?.timetable?.end_time
                    );
                    item.period_time = `${startTime} to ${endTime}`;
                  }
                });
              });
              console.log("what is n-->", timetableData);
              setTimeTableClass(timetableData.timeSlotsResult || []);
              setTempBody(timetableData.timeSlotsResult || []); // Store the initial data in tempBody
            } else {
              setTimeTableClass([]);
              setTempBody([]); // Clear tempBody if no data
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error?.response?.status === 401) {
          navigate("/login");
        }
      }
    }

    fetchData();
  }, [selectedStudent]);

  // const handleStudentHome = async (selectedStudent) => {
  //   console.log("handleStudentHome234=>", selectedStudent);
  //   if (selectedStudent?.id) {
  //     console.log("jhgssfhj");
  //     setStudentId(selectedStudent?.id);
  //   } else {
  //     setStudentId(selectedStudent);
  //   }
  // };

  // const handleStudentSessionIdHome = async (selectedSessionId) => {
  //   setSessionId(selectedSessionId);
  // };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <Card className="m-3 custom-card headerOfProject">
        <Row className="g-0 mx-2">
          <Col lg={10} className="text-center">
            <span style={{ fontWeight: "Arial", fontSize: "17px", marginLeft: "125px" }}>
              Student Time Table
            </span>
          </Col>
        </Row>
      </Card>
      <Card className="m-4 custom-card">
        <Container fluid style={{ marginTop: "15px" }}>
          <Row>
            <Col lg={12} className="text-center">
              <h3 style={{ fontWeight: "bold" }}>School Time Table</h3>
            </Col>
          </Row>
          <Table bordered className="printTimeTable mt-4">
            <thead>
              <tr className="timeTableEditRow">
                <th>Time Slot/Periods</th>
                <th>Monday</th>
                <th>Tuesday</th>
                <th>Wednesday</th>
                <th>Thursday</th>
                <th>Friday</th>
                <th>Saturday</th>
              </tr>
            </thead>

            <tbody>
              {timeTableClass && timeTableClass.length > 0
                ? (() => {
                    let validPeriodIndex = 0;

                    return timeTableClass.map((tsObj, index) => {
                      const slotType = tsObj?.time_slot?.type?.toLowerCase();
                      const isLunchOrBreak = slotType === "lunch" || slotType === "break";

                      const periodNumber = !isLunchOrBreak ? ++validPeriodIndex : null;

                      return (
                        <React.Fragment key={index}>
                          {tsObj?.time_slot?.status === "active" && (
                            <tr style={{ textAlign: "center" }} key={`period-${index}`}>
                              <td key={`period-${index}`} valign="middle">
                                {tsObj?.time_slot?.start_time + " to " + tsObj?.time_slot?.end_time || ""}
                                <br /> <br />
                                {console.log("periodNumber-->>" , periodNumber)}
                                {periodNumber && <p style={{ fontWeight: "bold" }}>(Period-{periodNumber})</p>}
                              </td>

                              {/* If it's lunch or break, show special row */}
                              {isLunchOrBreak ? (
                                <td
                                  colSpan={6}
                                  style={{
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    paddingTop: "20px",
                                  }}
                                >
                                  {slotType === "lunch" ? "Lunch Time" : "Break Time"}
                                </td>
                              ) : (
                                tsObj?.data?.map((slotData, slotIndex) => (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "5px",
                                    }}
                                    valign="middle"
                                    key={`slot-${slotIndex}`}
                                  >
                                    {slotData?.timetable?.contact_id && slotData?.timetable?.subject_id ? (
                                      <>
                                        <div name="teacher">{slotData?.timetable?.teacher}</div>
                                        <div name="subject">{slotData?.timetable?.subject}</div>
                                      </>
                                    ) : (
                                      <div style={{ color: "green" }}>Free Lecture</div>
                                    )}
                                  </td>
                                ))
                              )}
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    });
                  })()
                : null}
            </tbody>

          </Table>
        </Container>
      </Card>
    </>
  );
};

export default ClassTimeTable;
